import { useStore } from "vuex"
/**
 * Composable to handle interactions with the STORE regarding authentication
 * @returns functions that be accessed when calling the composable useAuth from any component
 */
export const useAuth = () => {

    const store = useStore()

    const loginUser = async ( user ) =>{
        const resp = await store.dispatch('auth_store/logInSipmovilUser', user)
        return resp
    }

    const verify2FA = async ( payload ) => {
        const resp = await store.dispatch('auth_store/verify2FA', payload)
        return resp
    }

    const resend2FA = async ( payload ) => {
        const resp = await store.dispatch('auth_store/resend2FA', payload)
        return resp
    }

    const restoreSession = async () => {
        const resp = await store.dispatch('auth_store/restoreSession')
        return resp
    }

    const toggle2FA = async () => {
        const resp = await store.dispatch('auth_store/toggle2FA')
        return resp
    }

    const request2FAActivation = async () => {
        const resp = await store.dispatch('auth_store/request2FAActivation')
        return resp
    }

    const confirm2FAActivation = async ( payload ) => {
        const resp = await store.dispatch('auth_store/confirm2FAActivation', payload)
        return resp
    }

    return{
        loginUser,
        verify2FA,
        resend2FA,
        restoreSession,
        toggle2FA,
        request2FAActivation,
        confirm2FAActivation,
    }
}

export default useAuth